"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileWebview = void 0;
const getSafeWindow_1 = require("./getSafeWindow");
const isMobileWebview = () => {
    const safeWindow = (0, getSafeWindow_1.getSafeWindow)();
    return safeWindow.ReactNativeWebView || safeWindow.webkit;
};
exports.isMobileWebview = isMobileWebview;
//# sourceMappingURL=isMobileWebview.js.map